(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TravelMediaPhoto',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var type,
			index;

		$('.btn.btn-default.btn-radio').on('click', function _choiceClicked() {
			type  = $(this).children().first().val();
			index = $(this).children().first().data('index');

			if (type === 'url') {
				$('.photo-link[data-index="' + index + '"]').removeClass('hidden');
				$('.photo-upload[data-index="' + index + '"]').addClass('hidden');
			} else {
				$('.photo-link[data-index="' + index + '"]').addClass('hidden');
				$('.photo-upload[data-index="' + index + '"]').removeClass('hidden');
			}

			if (index !== 1) {
				// show the additional photo upload form fields
				$('#photo_container_' + index).removeClass('hidden');
			}
		});

		$('.skip').on('click', function _skipClicked(e) {
			var num_photos    = $('#travelmediaphoto-num_photos').val(),
				links_added   = false,
				uploads_added = false,
				$i;

			e.preventDefault();

			for ($i = 0; $i < num_photos; $i++) {
				if ($('#travelmediaphoto-url-' + $i).val() !== '') {
					links_added = true;
				}

				if ($('#travelmediaphoto-dropped_count-appended-' + ($i + 1)).val() > 0) {
					uploads_added = true;
				}
			}

			if (links_added === true || uploads_added === true) {
				Adzuki.CustomConfirm({
					title  : 'Decision Time',
					content: 'You currently have selected photos to submit. Are you sure you want to skip submitting them at this time?',
					confirm: function confirm() {
						document.location = Adzuki.base_uri + '/TravelMedia/description/';
					}
				});
			} else {
				document.location = Adzuki.base_uri + '/TravelMedia/description/';
			}
		});
	};
}(jQuery, window.Adzuki || {}));